<template lang="pug">
v-container.party-contacts(fluid)
  v-row
    v-col.py-0(cols="6")
      app-entity-relation(
        v-model="currentParty",
        v-bind="{ entity, relation, parent, parentInstance, parentPath, path, invert, extraLoad, extraData, chips }"
        vertical,
        :disabled="isASN",
        @close="$emit('close')",
      )
        template(v-slot:label="props")
          h4.mb-0.primaryHover--text.border.primary-header.font-weight-bold {{title}}
    //- Contacts
    v-col.py-0(cols="6")
      app-entity-pivot(
        v-model="contactsList",
        :selectedParent="getCurrentParty",
        :entity="$findEntity('Contact')",
        :nodeEntity="$findEntity('ContactParty')"
        :mainEntity="$findEntity('Party')",
        :displayFields="['fullName', 'eMail', 'phoneNumber']",
        :hardCodedValues="{'contactType': partyContactType}",
        :hardCodedElementValues="{ contactParties: [] }",
        :searchLoad="['contact']",
        elementPath="contact",
        :disableCreateButton="isPartySelected",
        :entityProps="{ showParties: false }",
        v-bind="{ relation, parent, parentInstance, path, invert, extraLoad, entityAlias, createHardCodedValues }"
      )
</template>

<style lang="scss" scoped>
.party-contacts {
  ::v-deep .entity-controller_header {
    max-width: 350px;
  }
}
</style>

<script>
export default {
  props: {
    type: {
      type: String,
      default: null
    },
    isASN: {
      type: Boolean,
      default: false
    },
    invert: {
      type: Boolean,
      default: false
    },
    entity: null,
    relation: null,
    vertical: {
      type: Boolean,
      default: false
    },
    extraLoad: null,
    chips: null,
    parentInstance: null,
    parent: null,
    path: null,
    parentPath: null,
    showInfo: null,
    extraData: null,
    isSection: null,
    isActive: null,
    showTitle: {
      type: Boolean,
      default: true
    },
    entityAlias: ""
  },
  data: function() {
    return {
      availableContacts: [],
      currentParty: {}
    };
  },
  computed: {
    isPartySelected() {
      return !Object.keys(this.getCurrentParty || {}).some(p => p == "name");
    },
    title() {
      return this.type ? this.$t('Common.shipParty', {type: this.type}) : this.$t('Common.partyContacts');
    },
    getPartyName() {
      if (this.parent.name == "OrderLine") {
        return this.type && this.parentInstance && this.type === this.$t('Common.from')
          ? _.get(this.parentInstance.collectionPoint, "name", "")
          : _.get(this.parentInstance.deliveryPoint, "name", "");
      } else {
        return this.type && this.parentInstance && this.type === this.$t('Common.from')
          ? _.get(this.parentInstance.partyFrom, "name", "")
          : _.get(this.parentInstance.partyTo, "name", "");
      }
    },
    getCurrentParty() {
      if (this.parent.name == "OrderLine") {
        return this.type && this.parentInstance && this.type === this.$t('Common.from')
          ? this.parentInstance.collectionPoint
          : this.parentInstance.deliveryPoint;
      } else {
        return this.type && this.parentInstance && this.type === this.$t('Common.from')
          ? this.parentInstance.partyFrom
          : this.parentInstance.partyTo;
      }
    },
    contactsList: {
      get() {
        return this.$attrs.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    partyContactType() {
      return this.type === "From" ? 0 : 1;
    },
    createHardCodedValues() {
      if(!this.getCurrentParty) return {};
      return { contactParties: [{ _Entity: "ContactParty", entityState: 4, party: this.getCurrentParty }]};
    }
  },
  methods: {
    submitParty(partyVal) {
      this.$emit("update:party", partyVal);
    },
    submitContacts(contactsVal) {
      this.$emit("update:contacts", contactsVal);
    }
  }
};
</script>
